const ProdAside = () => {
    const productCatalog = [
      {
        categoryName: "Ville",
        products: [
          {
            name: "Yaounde",
            onClick: () => {
              console.log("Apple clicked");
            },
          },
          {
            name: "Douala",
            onClick: () => {
              console.log("Banana clicked");
            },
          },
          {
            name: "Baffoussam ",
            onClick: () => {
              console.log("Orange clicked");
            },
          },
        
        ],
      },
   
    ];
  
    return (
      <div className="h-full min-w-[192px] max-w-[192px] border-[#868889] border-solid border-r-[1px] py-4 flex justify-center">
        <div className="">
          {productCatalog.map((item, index) => (
            <div key={index} className="mb-8">
              <h3 className="font-[900] text-[18px] text-[#000000] mb-5">
                {item.categoryName}
              </h3>
              <div className="flex flex-col gap-3">
                {item.products.map((product, productIndex) => (
                  <div
                    key={productIndex}
                    onClick={product.onClick}
                    className="cursor-pointer hover:underline"
                  >
                    <span className="font-normal text-sm">{product.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  
  export default ProdAside;
  